import React from 'react';
import { LinearProgress, Box, Typography } from '@material-ui/core';
import { PlayCircleOutline, CheckCircle } from '@material-ui/icons';
import './VideoProgressBar.scss';

const VideoProgressBar = ({ 
  progress = 0, 
  showPercentage = true, 
  variant = 'default', // 'default', 'compact', 'detailed'
  currentTime = 0,
  duration = 0,
  isCompleted = false,
  className = ''
}) => {
  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const getProgressColor = () => {
    if (isCompleted) return 'success';
    if (progress >= 75) return 'primary';
    if (progress >= 25) return 'secondary';
    return 'primary';
  };

  const getProgressIcon = () => {
    if (isCompleted) {
      return <CheckCircle className="progress-icon completed" />;
    }
    if (progress > 0) {
      return <PlayCircleOutline className="progress-icon in-progress" />;
    }
    return <PlayCircleOutline className="progress-icon not-started" />;
  };

  if (variant === 'compact') {
    return (
      <Box className={`video-progress-bar compact ${className}`}>
        <LinearProgress
          variant="determinate"
          value={Math.min(progress, 100)}
          color={getProgressColor()}
          className="progress-bar-compact"
        />
        {showPercentage && (
          <Typography variant="caption" className="progress-text">
            {Math.round(progress)}%
          </Typography>
        )}
      </Box>
    );
  }

  if (variant === 'detailed') {
    return (
      <Box className={`video-progress-bar detailed ${className}`}>
        <Box className="progress-header">
          {getProgressIcon()}
          <Typography variant="body2" className="progress-status">
            {isCompleted ? 'Terminat' : progress > 0 ? 'În progres' : 'Neinceput'}
          </Typography>
          <Typography variant="caption" className="progress-percentage">
            {Math.round(progress)}%
          </Typography>
        </Box>
        
        <LinearProgress
          variant="determinate"
          value={Math.min(progress, 100)}
          color={getProgressColor()}
          className="progress-bar-detailed"
        />
        
        {duration > 0 && (
          <Box className="progress-time">
            <Typography variant="caption">
              {formatTime(currentTime)} / {formatTime(duration)}
            </Typography>
          </Box>
        )}
      </Box>
    );
  }

  // Default variant
  return (
    <Box className={`video-progress-bar default ${className}`}>
      <Box className="progress-info">
        {getProgressIcon()}
        {showPercentage && (
          <Typography variant="body2" className="progress-text">
            {Math.round(progress)}% completat
          </Typography>
        )}
      </Box>
      
      <LinearProgress
        variant="determinate"
        value={Math.min(progress, 100)}
        color={getProgressColor()}
        className="progress-bar-default"
      />
    </Box>
  );
};

export default VideoProgressBar;
